import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {WidgetProps} from "../../../../../common/ui/input/widget/widget";
import {propertyService} from "../../../../../../services/property/property.service";
import {SystemUser} from "../../../../../../models/users/user/system.user";

export const UIInputWidgetPropertyResponsibleUser: React.FC<WidgetProps> = ({value, onChange, multiple}) => {

    const [users, setUsers] = useState<SystemUser[]>([]);

    useEffect(() => {
        propertyService.getAllResponsibleUsers().then(users => {
            setUsers(users);
        });
    }, []);

    return (
        <Select
            mode={multiple ? "multiple" : undefined}
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
        >
            {users.map(user =>
                <Select.Option key={String(user.id)} value={user.id}>{user.firstName} {user.lastName}</Select.Option>)}
        </Select>
    )
}